'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // UI


var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      FullscreenCtaButton = _ref.FullscreenCtaButton,
      CloseButton = _ref.CloseButton,
      PlyrWrapper = _ref.PlyrWrapper;

  var MobilePlayer = function (_Component) {
    _inherits(MobilePlayer, _Component);

    function MobilePlayer() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, MobilePlayer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = MobilePlayer.__proto__ || Object.getPrototypeOf(MobilePlayer)).call.apply(_ref2, [this].concat(args))), _this), _this.uniqueClassName = (0, _uniqueId2['default'])('mobile-webinar-'), _this.renderStyle = function () {
        return _react2['default'].createElement('style', {
          type: 'text/css'
        }, '.' + _this.uniqueClassName + ' .plyr__video-embed, .' + _this.uniqueClassName + ' .plyr__video-embed__container {\n                padding-bottom: ' + _this.props.ratio + '% !important;\n            }');
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MobilePlayer, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            onCtaClick = _props.onCtaClick,
            onCloseClick = _props.onCloseClick,
            buttonProps = _props.buttonProps,
            playing = _props.playing,
            ctaVisible = _props.ctaVisible;
        return _react2['default'].createElement(_react2['default'].Fragment, null, this.renderStyle(), _react2['default'].createElement('div', {
          className: this.mobileOverlayClass
        }, _react2['default'].createElement(PlyrWrapper, {
          className: this.uniqueClassName
        }, children), playing && _react2['default'].createElement(_react2['default'].Fragment, null, _react2['default'].createElement(CloseButton, {
          onCloseClick: onCloseClick
        }), _react2['default'].createElement(FullscreenCtaButton, {
          onCtaClick: onCtaClick,
          buttonProps: buttonProps,
          ctaVisible: ctaVisible
        }))));
      }
    }, {
      key: 'mobileOverlayClass',
      get: function get() {
        var _props2 = this.props,
            theme = _props2.theme,
            playing = _props2.playing;
        return (0, _classnames2['default'])(theme.mobileOverlay, _defineProperty({}, theme.active, playing));
      }
    }]);

    return MobilePlayer;
  }(_react.Component);

  MobilePlayer.displayName = identifier;
  MobilePlayer.propTypes = {
    theme: _propTypes2['default'].object.isRequired,
    children: _propTypes2['default'].any.isRequired,
    ratio: _propTypes2['default'].number.isRequired,
    buttonProps: _propTypes2['default'].object.isRequired,
    playing: _propTypes2['default'].bool.isRequired,
    ctaVisible: _propTypes2['default'].bool.isRequired,
    onCloseClick: _propTypes2['default'].func.isRequired,
    onCtaClick: _propTypes2['default'].func.isRequired
  };
  return MobilePlayer;
};

exports['default'] = factory;